import {toast} from 'vue3-toastify';

// Константы для конфигурации
const DEFAULT_AUTO_CLOSE = 5000;
const TOAST_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error'
};

// Internal functions
const showToast = (msg, type = TOAST_TYPES.SUCCESS, autoClose = DEFAULT_AUTO_CLOSE) => {
    toast(msg, { autoClose, type });
};

const showToastWithCallbacks = (msg, onOpen, onClose, autoClose = DEFAULT_AUTO_CLOSE) => {
    toast(msg, {
        autoClose,
        type: TOAST_TYPES.SUCCESS,
        onOpen: typeof onOpen === 'function' ? onOpen : () => {},
        onClose: typeof onClose === 'function' ? onClose : () => {}
    });
}

// External functions
const toastErrors = (errors) => {
    if (!errors || typeof errors !== 'object') return;

    Object.values(errors).forEach(errorMsg => {
        if (typeof errorMsg === 'string') {
            showToast(errorMsg, TOAST_TYPES.ERROR);
        }
    });
};

const toastError = (msg) => {
    if (typeof msg === 'string') {
        showToast(msg, TOAST_TYPES.ERROR);
    }
};

const toastSuccess = (msg) => {
    if (typeof msg === 'string') {
        showToast(msg, TOAST_TYPES.SUCCESS);
    }
};

const toastSuccessWithCallBack = (msg, onOpen, onClose) => {
    if (typeof msg === 'string') {
        showToastWithCallbacks(msg, onOpen, onClose);
    }
};

const copyUrlSuccess = () => {
    showToast("Ссылка скопирована", TOAST_TYPES.SUCCESS);
};

const copyUrlError = () => {
    showToast("Ошибка копирования ссылки", TOAST_TYPES.ERROR);
};

export {
    toastError,
    toastErrors,
    toastSuccess,
    copyUrlSuccess,
    copyUrlError,
    toastSuccessWithCallBack
}